/**
 * 可折叠的容器
 * 
 * @Author: Focci
 * @Date: 2023-08-07 20:35:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 20:35:29
 */

'use client'

// import PropTypes from 'prop-types'
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'
import { isFunction } from 'lodash-es'

function Folding({
  height = 300,
  children,
  gradient = 'linear-gradient(to bottom, transparent, white 50%)',
  lessClassName = '',
  expandingClassName = '',
  Trigger = ButtonBase,
  TriggerProps = {
    className: 'text-primary',
    sx: (theme) => ({ color: theme.palette.primary.main })
  },
  triggerClassName = '',
  onToggle
}, ref) {
  const [expanding, setExpanding] = useState(false)
  const [showTrigger, setShowTrigger] = useState(false)
  const tc = useTranslations('common')
  const contentRef = useRef()

  const handleShowTrigger = useCallback(() => {
    const content = contentRef.current.getBoundingClientRect()
    setShowTrigger(content.height > height)
  }, [height])

  useEffect(() => {
    children && handleShowTrigger()
    window.addEventListener('resize', handleShowTrigger, false)

    return () => {
      window.removeEventListener('resize', handleShowTrigger, false)
    }
  }, [children, handleShowTrigger, height])

  function handleToggle() {
    setExpanding(!expanding)
    isFunction(onToggle) && onToggle(!expanding)
  }

  useImperativeHandle(ref, () => ({
    handleToggle: (v) => setExpanding(v)
  }))

  return (
    <div
      style={{ maxHeight: `${height}px` }}
      className={clsx([
        'overflow-hidden relative',
        expanding && '!max-h-max'
      ])}
    >
      <div ref={contentRef}>
        {children}
      </div>
      {showTrigger && (
        <div
          className={clsx([
            'text-f.8 pb-2',
            expanding ? 'mt-4' : 'absolute left-0 right-0 bottom-0 z-1 pt-12',
            expanding ? expandingClassName : lessClassName,
            triggerClassName
          ])}
          style={{ background: expanding ? '' : gradient }}
        >
          <Trigger
            onClick={handleToggle}
            {...TriggerProps}
          >
            {expanding ? tc('collapse') : tc('showMore')}
          </Trigger>
        </div>
      )}
    </div>
  )
}

export default forwardRef(Folding)

// Folding.propTypes = {
//   height: PropTypes.number,
//   children: PropTypes.node,
// }
